<template>
    <div  :class="['alt-form-group form-check',{'form-error': errorMessage}]" >      
      <div class="checkbox-form-group-wrapper">
        <input
          type="checkbox"
          :id="id"
          :value="modelValue"
          :checked="isChecked"
          class="form-check-input"
          @change="updateValue"
        />
      <svg>
        <use xlink:href="#checkmark-agree_terms"></use>
      </svg>
      <label :for="id" class="form-check-label">{{ label }}</label>
        <svg xmlns="http://www.w3.org/2000/svg" style="display: none">
          <symbol id="checkmark-agree_terms" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-miterlimit="10" fill="none" d="M22.9 3.7l-15.2 16.6-6.6-7.1">
            </path>
          </symbol>
        </svg>
      </div>
      <label :for="id" v-if="errorMessage" class="error">{{ errorMessage }}</label>
    </div>
  </template>
  
  <script setup lang="ts">
  
  interface Props {
    modelValue: boolean;
    label: string;
    rules?: Record<string, any>;
    id?: string | undefined;
    errorMessage?: string | null;
  }
  
  const props = defineProps<Props>();
  const isChecked = ref(props.modelValue);
  const emit = defineEmits(['update:modelValue','clearError']);
  
  const errorMessage = computed(() => props.errorMessage || '');

  // const validate = () => {
  //   if (props.rules?.required && !props.modelValue) {
  //     errorMessage.value = props.rules.errorMessage;
  //   } else {
  //     errorMessage.value = null;
  //   }
  // };
  watch(
    () => props.modelValue,
    (newValue) => {
      isChecked.value = newValue;
    }
  );
  const updateValue = (event: Event) => {
    const target = event.target as HTMLInputElement;
    // validate()
    emit('update:modelValue', target.checked);
    emit('clearError');
  };
  </script>
  